export default {
  name: 'Transfer |||| Transfers',
  subtitle: 'All transfers',
  list: {
    title: 'Transfers',
    sender: 'Sender',
    recipient: 'Recipient',
    postingDate: 'Posting date',
    baseAmount: 'Base amount',
    instructedAmount: 'Instructed amount',
    transferOperationType: 'Transfer operation type',
    transferCategory: 'Transfer category',
    amount: 'Amount',
    status: 'Status',
    reportingStatus: 'Reporting status',
    settled: 'Settled',
    fromAccountNumber: 'Sender (debit) account',
    toAccountNumber: 'Recipient (credit) account ',
    postedAt: 'Posted at',
    ledgerMappingStatusBySystem: 'Ledger mapping status',
    filters: {
      fromAccountNumber: 'Sender (debit) account number',
      toAccountNumber: 'Recipient (credit) account number',
      postingDateFrom: 'Posting date from',
      postingDateTo: 'Posting date to',
      currency: 'Currency',
      transferOperationType: 'Transfer operation type',
      transferCategory: 'Transfer category',
      fromProfileId: 'Sender (debit) profile ID',
      toProfileId: 'Recipient (credit) profile ID',
      transactionId: 'Head transaction ID',
      transferId: 'Transfer ID',
      postedAtFrom: 'Date & time from',
      postedAtTo: 'Date & time to',
      ledgerSystem: 'Ledger system',
      selectLedgerSystemHelper: 'Select ledger system status',
      selectLedgerSystemStatusHelper: 'Select ledger system',
      ledgerSystemStatus: 'Ledger system status',
      referenceId: 'Reference ID',
      ledgerMappingStatusBySystem: 'Ledger mapping status by system',
    },
  },
  show: {
    transferHeader: 'Transfer',
    postingDate: 'Posting date',
    postedAt: 'Posted at',
    transactionId: 'Head transaction ID',
    senderAccount: 'Sender account ',
    senderProfile: 'Sender (debit)',
    recipientAccount: 'Recipient account ',
    recipientProfile: 'Recipient (credit)',
    recipientProfileType: 'Recipient profile type',
    amount: 'Amount',
    transferOperationType: 'Transfer operation type',
    transferCategory: 'Transfer category',
    description: 'Description',
    ID: 'ID %{id}',
    transactionCreatedAt: 'Transaction date',
    detailsHeader: 'Transfer details',
    tabs: {
      details: 'Details',
    },
    ledgerMappingStatus: 'Ledger mapping status',
    lastError: 'Last error',
    lastErrorTimestamp: 'Last error timestamp',
    referenceId: 'Reference ID',
  },
  transferCategories: {
    _: 'Transfer category',
    any: 'Any',
    TRANSACTION: 'Transaction',
    PRINCIPAL: 'Principal',
    INTEREST: 'Interest',
    PENALTY: 'Penalty',
    FEE: 'Fee',
    TAX: 'Tax',
    LOYALTY: 'Loyalty',
    INSURANCE: 'Insurance',
    SAVINGS: 'Savings',
    ACQUIRING_FEE: 'Acquiring fee',
    CASH_ACQUIRING_FEE: 'Cash acquiring fee',
  },
  actions: {
    selectSystemToSkip: 'Select system to skip',
    skip: 'Skip',
    submit: 'Submit',
    attention: 'Attention required',
    skipAlert: 'Are you sure you want to skip for %{system}?',
    submitAlert: 'Are you sure you want to submit for %{system}?',
  },
};
